/**
 * @flow
 * @relayHash 551212a630c89c4bd4b03299e9ffd0c1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RemindAboutInvoiceInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type RemindAboutInvoiceMutationVariables = {|
  input: RemindAboutInvoiceInput
|};
export type RemindAboutInvoiceMutationResponse = {|
  +remindAboutInvoice: ?{|
    +success: ?boolean
  |}
|};
export type RemindAboutInvoiceMutation = {|
  variables: RemindAboutInvoiceMutationVariables,
  response: RemindAboutInvoiceMutationResponse,
|};
*/

/*
mutation RemindAboutInvoiceMutation(
  $input: RemindAboutInvoiceInput!
) {
  remindAboutInvoice(input: $input) {
    success
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'RemindAboutInvoiceInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'remindAboutInvoice',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'RemindAboutInvoicePayload',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'RemindAboutInvoiceMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'RemindAboutInvoiceMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'RemindAboutInvoiceMutation',
      id: null,
      text:
        'mutation RemindAboutInvoiceMutation(\n  $input: RemindAboutInvoiceInput!\n) {\n  remindAboutInvoice(input: $input) {\n    success\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '460ada59525c8298a7733235b887e0d6';
module.exports = node;
